<script>
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: 'WhatsAppGroupSend',
  components: { Dialog, Dropdown },
  data() {
    return {
      visible: false,
      loadingYears: false,
      sending: false,
      yearOptions: [],
      selectedYear: null,
      message: '',
    };
  },
  methods: {
    async openDialog() {
      this.visible = true;
      this.message = '';
      this.selectedYear = null;
      this.loadingYears = true;
      try {
        const res = await axios.get('/whatsapp/groups');
        this.yearOptions = (res.data.data || [])
          .filter(y => y.group !== null)
          .map(y => ({
            academic_year_id: y.id,
            label: `${y.year_title}  —  ${y.group.group_name}  (${y.group.participants_count} مشترك)`,
          }));
      } catch {
        this.yearOptions = [];
      } finally {
        this.loadingYears = false;
      }
    },
    async sendMessage() {
      if (!this.selectedYear) {
        Swal.fire({ icon: 'warning', title: 'تنبيه', text: 'يرجى اختيار السنة الدراسية / المجموعة' });
        return;
      }
      if (!this.message.trim()) {
        Swal.fire({ icon: 'warning', title: 'تنبيه', text: 'يرجى كتابة الرسالة' });
        return;
      }
      this.sending = true;
      try {
        const res = await axios.post('/whatsapp/groups/send', {
          academic_year_id: this.selectedYear.academic_year_id,
          message: this.message,
        });
        if (res.data.status) {
          this.visible = false;
          Swal.fire({ icon: 'success', title: 'تم الإرسال', text: 'تم إرسال الرسالة إلى المجموعة بنجاح', timer: 1500, showConfirmButton: false });
        } else {
          Swal.fire({ icon: 'error', title: 'خطأ', text: res.data.message || 'فشل الإرسال' });
        }
      } catch (e) {
        Swal.fire({ icon: 'error', title: 'خطأ', text: e.response?.data?.message || 'حدث خطأ غير متوقع' });
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<template>
  <!-- Temporarily disabled: originally opened the WhatsApp group-send dialog via @click="openDialog" (kept below, unused). -->
  <router-link to="/coming-soon" class="btn module-card__cta">
    <i class="pi pi-users me-1"></i>
    إرسال للمجموعة
  </router-link>

  <Dialog v-model:visible="visible" modal header="إرسال رسالة لمجموعة واتساب" :style="{ width: '32rem' }" :dismissableMask="true">
    <div class="row g-3">

      <div class="col-12">
        <label class="form-label">السنة الدراسية / المجموعة <span class="text-danger">*</span></label>

        <div v-if="loadingYears" class="text-center py-2">
          <i class="pi pi-spin pi-spinner-dotted text-success"></i>
          <span class="text-muted small ms-2">جاري التحميل...</span>
        </div>

        <Dropdown
          v-else
          v-model="selectedYear"
          :options="yearOptions"
          optionLabel="label"
          placeholder="اختر المجموعة"
          class="w-100"
          :emptyMessage="yearOptions.length === 0 ? 'لا توجد مجموعات مرتبطة — أضف من صفحة مجموعات واتساب' : 'لا نتائج'"
        />

        <div v-if="!loadingYears && yearOptions.length === 0" class="mt-1">
          <router-link to="/whatsapp_groups" class="small text-decoration-none text-success">
            <i class="pi pi-external-link me-1"></i>إدارة مجموعات واتساب
          </router-link>
        </div>
      </div>

      <div class="col-12">
        <label class="form-label">الرسالة <span class="text-danger">*</span></label>
        <textarea
          v-model="message"
          class="form-control"
          rows="5"
          placeholder="اكتب رسالتك هنا..."
          maxlength="4000"
        ></textarea>
        <div class="text-end mt-1">
          <span class="text-muted small">{{ message.length }} / 4000 حرف</span>
        </div>
      </div>

      <div class="col-12 pt-1">
        <button
          class="btn w-100 fw-bold"
          style="background:#25d366;color:#fff;border:none;"
          @click="sendMessage"
          :disabled="sending || !selectedYear || !message.trim()"
        >
          <i class="pi me-1" :class="sending ? 'pi-spin pi-spinner-dotted' : 'pi-send'"></i>
          {{ sending ? 'جاري الإرسال...' : 'إرسال للمجموعة' }}
        </button>
      </div>

    </div>
  </Dialog>
</template>

<style scoped>
</style>
